<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div slot="content">
      <div class="form-group col-md-12 col-sm-12 col-xs-12" v-show="callCenterConfig.id !== null">
        <label>Bật/tắt tính năng tổng đài</label>
        <b-form-checkbox v-model="callCenterConfig.is_enable" @change="updateCallCenterStatus()" switch size="lg"></b-form-checkbox>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Sản phẩm<span class="error-symbol"></span></label>
        <select id="productType" v-model="callCenterConfig.charge_by" class="form-control">
          <option v-for="productType in productTypes" :value="productType.code" :key="productType.code">{{ productType.name }}</option>
        </select>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Thanh toán<span class="error-symbol"></span></label>
        <select id="paymentType" v-model="callCenterConfig.payment_method" class="form-control">
          <option v-for="paymentType in paymentTypes" :value="paymentType.code" :key="paymentType.code">{{ paymentType.name }}</option>
        </select>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Ngày nhắc hạn<span class="error-symbol"></span></label>
        <date-picker v-model="callCenterConfig.payment_notify" valueType="format"></date-picker>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Hạn cần thanh toán<span class="error-symbol"></span></label>
        <date-picker v-model="callCenterConfig.payment_date" valueType="format"></date-picker>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Ngày bắt đầu tính cước<span class="error-symbol"></span></label>
        <date-picker v-model="callCenterConfig.payment_start_date" valueType="format"></date-picker>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Phí theo agent</label>
        <currency-input class="form-control" v-model.number="callCenterConfig.agent_fee" placeholder="Nhập phí theo agent..."/>
      </div>

      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Số tiền đặt cọc</label>
          <currency-input class="form-control" v-model.number="callCenterConfig.deposit" placeholder="Nhập số tiền đặt cọc..."/>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Mức giá cảnh báo đặt cọc (%)</label>
        <input type="number" min=0 max="100" class="form-control" v-model.number="callCenterConfig.deposit_warning_threshold" placeholder="Nhập mức giá cảnh ức đặt cọc..."/>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Mức giá áp dụng</label>
        <b-table    bordered outlined hover responsive :busy="loading" :fields="price_fields" :items="price_items"
                    show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template #empty="scope">
            <h6 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h6>
          </template>

          <template v-slot:cell(id)="data">
            {{ genSeqId(data) }}
          </template>
          <template v-slot:cell(call_date)="data">
            {{ data.item.call_date | format_date }}
          </template>
          <template v-slot:cell(start_time)="data">
            {{ data.item.call_date | format_date_time}}
          </template>
          <template v-slot:cell(end_time)="data">
            {{ addTime(data.item.call_date, data.item.duration) | format_date_time}}
          </template>

        </b-table>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Tổng chi phí: {{total_fee | format_currency}} (vnđ)</label>
      </div>

      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <div class="d-flex justify-content-between mb-2">
          <label>Số agent đăng ký sử dụng</label>
          <b-button variant="warning" v-b-tooltip.hover title="Thêm mới" @click="addNew()"><i class="fa fa-plus" aria-hidden="true"></i></b-button>
        </div>
        <b-table    bordered outlined hover responsive :busy="loadingAgent" :fields="fields" :items="callCenterConfig.agents" show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template v-slot:cell(number)="data">
            <span v-if="!data.item.isAddNew">{{data.item.number}}</span>
            <input v-else type="number" class="form-control" v-model.number="data.item.number" placeholder="Nhập số lượng..."/>
          </template>

          <template v-slot:cell(use_from)="data">
            <span v-if="!data.item.isAddNew">{{data.item.use_from}}</span>
            <date-picker v-else v-model="data.item.use_from" valueType="format"></date-picker>
          </template>

          <template v-slot:cell(use_to)="data">
            <span v-if="!data.item.isAddNew">{{data.item.use_to}}</span>
            <date-picker v-else v-model="data.item.use_to" valueType="format"></date-picker>
          </template>
          <template v-slot:cell(charge_from)="data">
            <span v-if="!data.item.isAddNew">{{data.item.charge_from}}</span>
            <date-picker v-else v-model="data.item.charge_from" valueType="format"></date-picker>
          </template>
          <template v-slot:cell(charge_to)="data">
            <span v-if="!data.item.isAddNew">{{data.item.charge_to}}</span>
            <date-picker v-else v-model="data.item.charge_to" valueType="format"></date-picker>
          </template>

          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button v-if="data.item.isAddNew" variant="warning" v-b-tooltip.hover title="Lưu" @click="saveAgent(data.item)"><i class="fa fa-floppy-o"/></b-button>
            <b-button v-if="data.item.isAddNew" variant="danger" v-b-tooltip.hover title="Xoá" @click="discardAgent(data.item)"><i class="fa fa-times"/></b-button>
            <b-button v-if="!data.item.isAddNew" variant="danger" v-b-tooltip.hover title="Xoá" @click="deleteAgent(data.item)"><i class="fa fa-trash"/></b-button>
            <b-button v-if="!data.item.isAddNew" variant="success" v-b-tooltip.hover title="Nhập danh sách EXT" @click="openImportExtModal(data.item.id)">
              <i class="fa fa-cloud-upload" aria-hidden="true"></i>
            </b-button>
            <b-button v-if="!data.item.isAddNew" variant="warning" v-b-tooltip.hover title="Tải về file mới nhất" @click="downloadModal(data.item.id)">
              <i class="fa fa-cloud-download" aria-hidden="true"></i>
            </b-button>
          </template>

        </b-table>
      </div>
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Hình thức tính sip phút</label>
        <select id="sipMethod" v-model="callCenterConfig.sip_fee_calculation" class="form-control">
          <option v-for="sipMethod in sipMethods" :value="sipMethod.code" :key="sipMethod.code">{{ sipMethod.name }}</option>
        </select>
      </div>
      <div class="form-group col-md-6 col-sm-12 col-xs-12">
        <label>Hình thức giảm giá</label>
        <select id="discountType" v-model="callCenterConfig.discount_type" class="form-control">
          <option v-for="discountType in discountTypes" :value="discountType.code" :key="discountType.code">{{ discountType.name }}</option>
        </select>
      </div>

      <div class="form-group col-md-6 col-sm-12 col-xs-12">
        <label>Giảm giá</label>
        <input type="number" class="form-control" v-model.number="callCenterConfig.discount_value" placeholder="Nhập giảm giá..."/>
      </div>
    </div>
    <div slot="footer" class="col-md-12 col-sm-12 col-xs-12">
      <div class="pull-right mt-3">
        <b-button variant="success" class="w-150px" @click="save">Lưu</b-button>
      </div>
    </div>
    <b-modal size='xl' id="importExtModal" hide-footer title="Nhập EXT">
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <b-form-file
          v-model="extFile"
          :state="Boolean(extFile)"
          accept="text/csv"
          placeholder="Chọn file csv hoặc thả vào đây..."
          drop-placeholder="Thả file vào đây..."
          required
        ></b-form-file>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div v-show="error_call_agents.length > 0">Danh sách ext bị lỗi: </div>
        <div class="text-danger" v-for="call_agent in error_call_agents" :key="call_agent">{{call_agent}}</div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="success" class="w-150px" @click="handleUploadExtFile">Import</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import Utils from '../common/utils'
import moment from 'moment'
import {CALL_CENTER_CONFIG, PROVIDER_NAME} from '../common/constant'
import CallCenterApi from '../api/callCenter'

export default {
  name: 'CallCenterConfig',
  props: {
    company: {
      type: Object,
      required: true
    },
    hideModal: {
      type: Function,
      required: true
    },
  },
  components: {
    DatePicker,
  },
  mounted () {
    this.getCallCenter()
    this.getPackage()
  },
  data () {
    return {
      saved: false,
      callCenterConfig: {
        id: null,
        company_id: this.company.id,
        is_enable: false,
        charge_by: 'AGENT',
        payment_method: 'DEBIT',
        payment_notify: moment().format('yyyy-MM-DD'),
        payment_date: moment().format('yyyy-MM-DD'),
        payment_start_date: moment().format('yyyy-MM-DD'),
        agent_fee: 0,
        deposit: 0,
        deposit_warning_threshold: 0,
        sip_fee_calculation: '6+1',
        agents: [],
        external_fee: 0,
        discount_type: 'VALUE',
        discount_value: 0
      },
      loadingAgent: false,
      fields: [
        {
          key: 'number',
          label: 'Số lượng'
        },
        {
          key: 'use_from',
          label: 'Ngày bắt đầu sử dụng'
        },
        {
          key: 'use_to',
          label: 'Ngày kết thúc sử dụng'
        },
        {
          key: 'charge_from',
          label: 'Ngày bắt đầu thanh toán'
        },
        {
          key: 'charge_to',
          label: 'Ngày kết thúc thanh toán'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 150px',
          class: 'actions-cell'
        }
      ],
      packages: {
        viettel: [],
        mobifone: [],
        vinaphone: [],
        other: [],
      },
      packageActiveTab: 'viettel',
      productTypes: CALL_CENTER_CONFIG.PRODUCT_TYPES,
      paymentTypes: CALL_CENTER_CONFIG.PAYMENT_TYPES,
      sipMethods: CALL_CENTER_CONFIG.SIP_METHOD,
      discountTypes: CALL_CENTER_CONFIG.DISCOUNT_TYPES,
      loading: false,
      saving: false,
      extFile: null,
      current_register_id: null,
      price_items: [],
      price_fields: [
        {
          key: 'provider',
          label: 'Nhà mạng'
        },
        {
          key: 'total_minute',
          label: 'Tổng số phút gọi'
        },
        {
          key: 'price',
          label: 'Giá 1 phút gọi (vnđ)'
        }
      ],
      error_call_agents: [],
      total_fee: 0
    }
  },
  methods: {
    updateCallCenterStatus () {
      CallCenterApi.updateStatus(this.callCenterConfig.is_enable, this.company.id).then(res => {
        if (res != null && res.data != null) {
          Utils.successToast(this.$bvToast)
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    getPackage () {
      if (this.company.call_center) {
        let filterCredit = {
          report_type: 'CURRENT_MONTH',
          company_id: this.company.id
        }
        CallCenterApi.get_credit_payment_report(filterCredit).then(res => {
          let creditPayment = res.data.data

          this.total_fee = creditPayment.total_payment_amount
          if (creditPayment.current_prices !== null && creditPayment.current_minutes !== null) {
            this.price_items = PROVIDER_NAME.map(item => {
              return {
                provider: item === 'other' ? 'Ngoại mạng' : item,
                total_minute: creditPayment.current_minutes[item],
                price: creditPayment.current_prices[item],
              }
            })
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    getCallCenter () {
      if (this.company.call_center) {
        CallCenterApi.get_callcenter({company_id: this.company.id}).then(res => {
          if (res != null && res.data != null) {
            if (res.data.data.id) {
              this.callCenterConfig = {...res.data.data, agents: []}
            }
          }
          this.getAgents()
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    getAgents () {
      this.loadingAgent = true
      this.callCenterConfig.agents = []
      CallCenterApi.filter_agent_register({company_id: this.company.id}).then(res => {
        this.loadingAgent = false
        if (res != null && res.data != null) {
          this.callCenterConfig.agents.push(...res.data.data.records)
        }
      }).catch(err => {
        this.loadingAgent = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    save () {
      if (this.callCenterConfig.id) {
        CallCenterApi.update_callcenter(this.callCenterConfig).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            this.hideModal()
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        CallCenterApi.create_callcenter(this.callCenterConfig).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            this.hideModal()
            this.getCallCenter()
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    openImportExtModal (agentRegisterId) {
      this.$bvModal.show('importExtModal')
      this.current_register_id = agentRegisterId
    },
    downloadModal () {
      CallCenterApi.downloadExtFile(this.company.id).then(response => {
        const blob = new Blob([response.data], { type: 'text/csv' })
        const url = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')
        fileLink.href = url
        fileLink.setAttribute('download', 'ext_file.csv')
        document.body.appendChild(fileLink)
        fileLink.click()
      }).catch(() => {})
    },
    handleUploadExtFile () {
      if (this.extFile) {
        if (this.extFile.type !== 'text/csv') {
          Utils.warnToast(this.$bvToast, 'Định dạng file không đúng', 'Vui lòng tải lên file có định dạng csv')
        } else {
          const extFormData = new FormData()
          extFormData.append('file', this.extFile)
          extFormData.append('company_id', this.company.id)
          extFormData.append('agent_register_id', this.current_register_id)
          CallCenterApi.uploadExtFile(extFormData).then(res => {
            this.error_call_agents = res.data.data.error_call_agents
            if (this.error_call_agents.length === 0) {
              this.$bvModal.hide('importExtModal')
              Utils.successToast(this.$bvToast, 'Import danh sách EXT', 'Đã upload & import thành công')
            } else {
              Utils.warnToast(this.$bvToast, 'Import danh sách EXT', 'Vui lòng kiểm tra lại các EXT sau đây. Có thể bị trùng hoặc lỗi.')
            }
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      }
    },
    addNew () {
      const newRecord = {
        id: this.$uuid.v1(),
        number: 0,
        company_id: this.company.id,
        use_from: moment().format('yyyy-MM-DD'),
        use_to: moment().format('yyyy-MM-DD'),
        charge_from: moment().format('yyyy-MM-DD'),
        charge_to: moment().format('yyyy-MM-DD'),
        isAddNew: true
      }
      if (this.callCenterConfig.agents) {
        this.callCenterConfig.agents.push(newRecord)
      } else {
        this.callCenterConfig.agents = []
        this.callCenterConfig.agents.push(newRecord)
      }
    },
    saveAgent (agent) {
      if (this.callCenterConfig.id === null) {
        CallCenterApi.create_callcenter(this.callCenterConfig).then(res => {
          CallCenterApi.create_agent_register(agent).then(res => {
            if (res != null && res.data != null) {
              Utils.successToast(this.$bvToast)
              this.getAgents()
            }
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        CallCenterApi.create_agent_register(agent).then(res => {
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.getAgents()
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    discardAgent (agent) {
      this.callCenterConfig.agents = this.callCenterConfig.agents.filter(item => item.id !== agent.id)
    },
    deleteAgent (agent) {
      if (agent.id) {
        this.$bvModal.msgBoxConfirm('Xóa Agent. Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            CallCenterApi.delete_agent_register(agent).then(res => {
              Utils.successToast(this.$bvToast)
              this.getAgents()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CallCenterConfig.vue